(function ($, ajax_localize) {
	$(document).ready(function () {

		if ($("body").hasClass("single-rit-tour")) {

			handle_tab_deep_linking(window.location.hash, false);

			$("body.single-rit-tour > .main").find('a[href^="#"]:not(.card-link)').on("click", function (evt) {

				return handle_tab_deep_linking($(this).attr("href"));

			});

		}

		let last_tab_id = "";

		$("#tour-content-tabs-nav-list").find('.nav-link[data-bs-toggle="tab"]').on("click", function (evt) {

			let current_tab_pane_id = $(this).data("bs-target");

			if (last_tab_id !== current_tab_pane_id) {

				let tour_info_header_height = Math.round($("body.single-rit-tour > .main > .tour-header-wrap").outerHeight());

				let scroll_position = $("#tour-content-tabs-content-panes").offset().top;

				if ($(window).width() >= 992) {
					scroll_position -= (tour_info_header_height - 20);
				}

				$("html, body").animate({
					scrollTop: scroll_position
				}, "fast");

			}

			last_tab_id = current_tab_pane_id;

		});

		$("#tour-content-tabs-mobile-dropdown").on("change", function (evt) {

			let selected_tab_id = $(evt.target).val().replace("#", "") + '-tab';

			let selected_tab = $("#tour-content-tabs-nav-list").find('.nav-link[data-bs-toggle="tab"][id="' + selected_tab_id + '"]');

			if (selected_tab.length > 0) {
				selected_tab.trigger("click");
			}

		});

		$(".inclusions-post-slider").each(function () {

			let slider_id = $(this).data('block-id');
			let autoplay = $(this).data('autoplay');
			let slides_to_show = $(this).data('slides-to-show');

			let num_slides = $(this).find(".post-slide").length;

			/**
			 * Initialize the carousel.
			 */
			$(this)
				.on("init reInit", function (event, slick) {

					toggle_slider_btn_visibility($(this).closest(".itinerary-day-inclusions-slider-wrap"), slick.getOption("slidesToShow"), num_slides);

				})
				.on("breakpoint", function (event, slick, breakpoint) {

					toggle_slider_btn_visibility($(this).closest(".itinerary-day-inclusions-slider-wrap"), slick.getOption("slidesToShow"), num_slides);

				})
				.slick({
					infinite: false,
					slidesToShow: slides_to_show,
					slidesToScroll: 1,
					autoplay: autoplay,
					pauseOnHover: autoplay,
					arrows: false,
					// centerMode: Boolean(post_overflow),
					appendDots: $('.inclusions-slider-container'),
					responsive: [
						{
							breakpoint: 1120,
							settings: {
								slidesToShow: 3,
							}
						},
						{
							breakpoint: 992,
							settings: {
								slidesToShow: 2,
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
							}
						},
					]
				});



			let inclusions_slider_wrap = $(this).closest(".itinerary-day-inclusions-slider-wrap");

			/**
			 * Hook up the controls.
			 */
			inclusions_slider_wrap.find('.previous-button.slider-' + slider_id).click(function () {
				$('#slider-' + slider_id).slick('slickPrev');
			});

			inclusions_slider_wrap.find('.next-button.slider-' + slider_id).click(function () {
				$('#slider-' + slider_id).slick('slickNext');
			});

		});

		$(".js-expand-all-accordions-btn").on("click", function () {

			let target_accordion_id = $(this).data("target");

			if ($(target_accordion_id).length > 0) {

				$(this).toggleClass("active");

				if ($(this).hasClass("active")) {

					$(target_accordion_id).find(".accordion-collapse").collapse("show");

					$(this).text($(this).data("collapse-label"));

				} else {

					$(target_accordion_id).find(".accordion-collapse").collapse("hide");

					$(this).text($(this).data("expand-label"));

				}

			}

		});

		$("#tour-itinerary-accordion").find(".accordion-collapse").on("show.bs.collapse", function (evt) {

			if ($(this).find(".inclusions-post-slider").length > 0) {

				$(this).find(".inclusions-post-slider").slick("refresh");

				let slick_obj = $(this).find(".inclusions-post-slider").slick("getSlick");

				let slides_to_show = slick_obj.getOption("slidesToShow");

				let num_slides = $(this).find(".inclusions-post-slider .post-slide").length;

				toggle_slider_btn_visibility($(this).find(".itinerary-day-inclusions-slider-wrap"), slides_to_show, num_slides, true);

			}

		});

		$(".js-departures-listing-filter-btn").on("click", function (evt) {

			load_more_tours($(evt.target).attr("data-year"), $(evt.target).attr("data-month"));

		});

		$("#departures-listing-year-filter-mobile-dropdown").on("change", function (evt) {

			let active_months = $(evt.target).find("option:selected").data("active-months").split(",");

			$("#departures-listing-month-filter-mobile-dropdown").find("option").remove();

			active_months.forEach((month_num) => {

				let month_date = new Date($(evt.target).val(), (month_num - 1), 1);

				let option_element = $("<option>").val(month_num).text(month_date.toLocaleString('default', { month: 'long' }));

				$("#departures-listing-month-filter-mobile-dropdown").append(option_element);

			});

			load_more_tours($(evt.target).val(), active_months[0]);

		});

		$("#departures-listing-month-filter-mobile-dropdown").on("change", function (evt) {

			load_more_tours($("#departures-listing-year-filter-mobile-dropdown").val(), $(evt.target).val());

		});

		if ($("#slider-tour-details-related-tours").length > 0) {

			let related_tours_slider = $("#slider-tour-details-related-tours");

			let slider_id = related_tours_slider.data("block-id");
			let autoplay = related_tours_slider.data("autoplay");
			let slides_to_show = related_tours_slider.data("slides-to-show");

			let num_slides = related_tours_slider.find(".post-slide").length;

			let is_infinite = (num_slides > slides_to_show);

			/**
			 * Initialize the carousel.
			 */
			related_tours_slider
				.on("init", function (event, slick) {

					toggle_slider_btn_visibility(related_tours_slider.closest(".post-slider-block"), slick.getOption("slidesToShow"), num_slides);

				})
				.on("breakpoint", function (event, slick, breakpoint) {

					toggle_slider_btn_visibility(related_tours_slider.closest(".post-slider-block"), slick.getOption("slidesToShow"), num_slides);

				})
				.slick({
					infinite: is_infinite,
					slidesToShow: slides_to_show,
					slidesToScroll: 1,
					autoplay: autoplay,
					pauseOnHover: autoplay,
					arrows: false,
					// centerMode: Boolean(post_overflow),
					appendDots: $('.main-slider-container'),
					responsive: [
						{
							breakpoint: 1120,
							settings: {
								slidesToShow: 3,
								infinite: (num_slides > 3),
							}
						},
						{
							breakpoint: 992,
							settings: {
								slidesToShow: 2,
								infinite: (num_slides > 2),
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								infinite: (num_slides > 1),
							}
						},
					]
				});

			let related_tours_section = related_tours_slider.closest("#single-tour-related-tours");

			// If all the tours in the slider are being displayed without having to slide, hide the controls
			if (num_slides > slides_to_show) {

				/**
				 * Hook up the controls.
				 */
				related_tours_section.find('.previous-button.slider-' + slider_id).click(function () {
					related_tours_slider.slick('slickPrev');
				});

				related_tours_section.find('.next-button.slider-' + slider_id).click(function () {
					related_tours_slider.slick('slickNext');
				});
			}

		}

		function toggle_slider_btn_visibility(slider_wrapper, slides_to_show, num_slides, force_update = false) {

			let slider_btns_container = slider_wrapper.find(".control-container");

			if (num_slides > slides_to_show) {

				if (slider_btns_container.is(":hidden") || force_update) {
					slider_btns_container.show();
				}

			} else if (slider_btns_container.is(":visible") || force_update) {

				slider_btns_container.hide();

			}

		}

		function handle_tab_deep_linking(url_hash, triggered_by_link = true) {

			let tour_info_header_height = Math.round($("body.single-rit-tour > .main > .tour-header-wrap").outerHeight());

			if (url_hash.length > 1) {

				let anchor_link_parts = url_hash.replace(/^(#|\/)|\/$/g, "").split("|");

				let tab_to_open = $("#tour-content-tabs-nav-list").find('.nav-link[data-bs-toggle="tab"][id="' + anchor_link_parts[0] + '-tab"]');

				// If tab to open exists, open it, otherwise let click behaviour continue
				if (tab_to_open.length > 0) {

					if (!tab_to_open.hasClass("active")) {
						tab_to_open.tab("show");
					}

					if ($(window).width() < 992) {

						$("#tour-content-tabs-mobile-dropdown").val("#" + anchor_link_parts[0]);

					}

					let opened_tab_pane = $("#" + anchor_link_parts[0]);

					// Set default position to scroll to after opening the tab to the top of the tab content
					let scroll_position = opened_tab_pane.offset().top;

					if ($(window).width() >= 992) {

						scroll_position -= (tour_info_header_height - 20);

					}

					let do_scroll = triggered_by_link;

					if ((anchor_link_parts.length > 1) && (opened_tab_pane.find("#" + anchor_link_parts[1]).length > 0)) {

						scroll_position = opened_tab_pane.find("#" + anchor_link_parts[1]).offset().top;

						// Always scroll after opening the tab when element ID inside tab is included in hash.
						do_scroll = true;
					}

					if (do_scroll) {

						$("html, body").animate({
							scrollTop: scroll_position
						}, "slow");

						return false;

					}

				}

			}

			return true;

		}

		let tour_listing_filter_xhr = null;

		function load_more_tours(year_num, month_num) {

			let list_item_holder = $("#departures-list-holder");

			let list_items_loader = $(".list-items-loader", list_item_holder);

			//if (loadMoreBtn.is(".loading") && loadMoreXHR != null) {
			if (tour_listing_filter_xhr != null) {
				tour_listing_filter_xhr.abort();
			}

			// Save the button's text so we can restore it when removing the loading state
			/*var origButtonText = loadMoreBtn.html();

			loadMoreBtn
				.attr("disabled", true)
				.addClass("loading")
				.text("Loading...");*/

			let action = "get_tour_departures";

			let list_loader_data = list_items_loader.data();

			let request_data = {
				"tour_post_id": list_loader_data['postId'],
				"year": year_num,
				"month": month_num,
				"args": list_loader_data['args'],
			};
			console.log(request_data);
			tour_listing_filter_xhr = $.post(
				ajax_localize.ajax_url,
				{
					"action": action,
					"data": $.param(request_data),
				},
				function (data) {

					// If new items were returned
					if (data) {

						// Remove the existing list item loader since a new one will be included in the response
						list_items_loader.remove();

						/*loadMoreBtn
							.attr("disabled", false)
							.removeClass("loading")
							.html(origButtonText);*/

						tour_listing_filter_xhr = null;

						let new_list_items = $($.parseHTML(data));

						list_items_loader = new_list_items.filter(".list-items-loader");

						list_item_holder.fadeOut(400, function () {

							$(this).empty().append(new_list_items);

							$(this).fadeIn(400);

							// Update attributes on next and previous month buttons so they pull the correct month when clicked next time.
							let prev_month_btn = $(this).closest(".departures-listing-section").find(".pagination-column-previous .btn");

							let next_month_btn = $(this).closest(".departures-listing-section").find(".pagination-column-next .btn");

							let list_loader_data = list_items_loader.data();

							if (list_loader_data.hasOwnProperty("prevYearMonth") && (list_loader_data.prevYearMonth !== "")) {

								let prev_year_month_parts = list_loader_data.prevYearMonth.split("-");

								if (prev_year_month_parts.length > 1) {

									prev_month_btn.attr("data-year", prev_year_month_parts[0]);
									prev_month_btn.attr("data-month", prev_year_month_parts[1]);

									if (prev_month_btn.is(":disabled")) {
										prev_month_btn.prop("disabled", false);
									}

								}


							} else if (!prev_month_btn.is(":disabled")) {

								prev_month_btn.prop("disabled", true);

							}

							if (list_loader_data.hasOwnProperty("nextYearMonth") && (list_loader_data.nextYearMonth !== "")) {

								let next_year_month_parts = list_loader_data.nextYearMonth.split("-");

								if (next_year_month_parts.length > 1) {

									next_month_btn.attr("data-year", next_year_month_parts[0]);
									next_month_btn.attr("data-month", next_year_month_parts[1]);

									if (next_month_btn.is(":disabled")) {
										next_month_btn.prop("disabled", false);
									}

								}

							} else if (!next_month_btn.is(":disabled")) {

								next_month_btn.prop("disabled", true);

							}

							let month_filter_btn_lists = $(this).closest(".tour-tab-pane").find(".departures-listing-filter-buttons-list");

							let new_active_month_filter_btn = month_filter_btn_lists.find('.btn-month-filter[data-year="' + year_num + '"][data-month="' + month_num + '"]');

							if ((new_active_month_filter_btn !== null) && (new_active_month_filter_btn.length > 0)) {

								month_filter_btn_lists.find(".btn-month-filter.active").removeClass("active");

								new_active_month_filter_btn.addClass("active");

							}

							if ($(window).width() < 992) {

								$("#departures-listing-year-filter-mobile-dropdown").children('[value="' + year_num + '"]').get(0).selected = true;
								$("#departures-listing-month-filter-mobile-dropdown").children('[value="' + month_num + '"]').get(0).selected = true;

							}

						});

					}

				}
			);

		}

	});

})(jQuery, ajax_localize);